import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

export const ActorCardCmp_Organization_Fragment = graphql(`
  fragment ActorCardCmp_Organization_Fragment on Organization {
    _id
    isInternal
    isVip
    color
    logoImageUri
    identifier {
      kind
      value
    }
    name
    tradingName
    contactInfo {
      ...ContactInfoCmp_ContactInfo_Fragment
    }
    allMemberships {
      personId
      statusId
      contextualRoleIds
      representativeTypeIds
      ...ActorCardCmp_OrganizationMembership_Fragment
    }
    categoryIds
    activity
  }
`);

export type ActorCardCmp_Organization = ResultOf<
  typeof ActorCardCmp_Organization_Fragment
>;
